/** Card UUID from a /card/:id path, if any. */
export function cardIdFromDetailPath(path) {
  if (!path) return null
  const p = path.split('?')[0]
  const m = p.match(/^\/card\/([^/]+)\/?$/)
  return m ? m[1] : null
}

/** Resolved in-app path for a notification (profile, owner, card detail, ...). */
export function resolveNotificationPath(notification) {
  const raw = String(notification?.actionUrl ?? '').trim()
  if (raw) {
    if (raw.startsWith('http://') || raw.startsWith('https://')) {
      try {
        const pathname = new URL(raw).pathname
        return pathname || null
      } catch {
        return null
      }
    }
    return raw.startsWith('/') ? raw : `/${raw}`
  }
  const cardId = notification?.cardId || notification?.card?.id
  if (cardId) return `/card/${cardId}`
  return null
}

/** Prefer opening My Cards chain-of-custody; fall back to the notification path. */
export function ownerFocusCardIdFromNotification(notification, path) {
  const fromPath = cardIdFromDetailPath(path)
  return fromPath || notification?.cardId || notification?.card?.id || null
}
